import { User } from '@/domain/types/user';
import { Column } from '@/presentation/components/table';

export const columns: Column<User>[] = [
  { header: 'Documento', accessor: 'document' },
  { header: 'Nombre', accessor: 'name' },
  { header: 'Apellido', accessor: 'lastname' },
  { header: 'Email', accessor: 'email' },
  { header: 'Departamento', accessor: 'department' },
  { header: 'Área', accessor: 'area' },
  { header: 'Unidad', accessor: 'unit' },
  { header: 'Cargo', accessor: 'position' },
  { header: 'Rol', accessor: 'role' },
];
